module.exports = __webpack_public_path__ + "img/cooperativa_san_cristobal.81d5e171.png";